import styled, { css } from 'styled-components';
import { breakpoint } from '../theme/breakpoint';
import { Card } from '../content-card/styles';

export const CardRow = styled.div`
  display: grid;

  ${breakpoint.tablet`
    ${({ $columns, theme }) =>
      $columns &&
      css`
        grid-template-columns: repeat(${$columns}, minmax(0, 1fr));
        column-gap: ${theme.spacing.standard};
      `}}
  `};

  ${Card} {
    &:last-of-type {
      margin-bottom: ${({ theme }) => theme.spacing.standard};
    }

    ${breakpoint.tablet`
      ${({ theme }) =>
        css`
          margin-bottom: ${theme.spacing.standard};
        `}
    `};
  }
`;
